/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { VaultProviderAttributes } from '../models/VaultProviderAttributes';

export class BackupVault {
  /**
  * Vault ID.
  */
  'id': string;
  /**
  * Eon-assigned ID of the vault account.
  */
  'vaultAccountId': string;
  /**
  * Cloud provider-assigned ID of the vault account.
  */
  'providerAccountId': string;
  /**
  * Vault display name.
  */
  'name': string;
  /**
  * Region where the vault is located.
  */
  'region': string;
  /**
  * Whether the vault is in an Eon-managed vault account.
  */
  'isManagedByEon': boolean;
  'vaultAttributes': VaultProviderAttributes;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "vaultAccountId",
      "baseName": "vaultAccountId",
      "type": "string",
      "format": ""
    },
    {
      "name": "providerAccountId",
      "baseName": "providerAccountId",
      "type": "string",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "isManagedByEon",
      "baseName": "isManagedByEon",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "vaultAttributes",
      "baseName": "vaultAttributes",
      "type": "VaultProviderAttributes",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return BackupVault.attributeTypeMap;
  }

  public constructor() {
  }
}

